import BasePaymentMethod from './basePaymentMethod.jsx'

export default class PaymentGate extends BasePaymentMethod {
  constructor (payment) {
    super(payment)
    this.displayName = 'Payment Gate'
  }

  eligible () {
    return this.payment.booking.booking.paymentMethods.paymentGate
  }

  book () {
    return this.payment.booking.payWithPaymentGate(this.payment.calculatePaymentAmount())
  }
}

